module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-khabib-nurmagomedov-1.b2bd7a2e.png";